/*
  StepperModule
  Main UI module that manages the availability of all UI-related components
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StepperComponent } from './stepper.component';
import { StepperSectionComponent } from './stepper-section.component';
import { StepperHeaderComponent } from './stepper-header.component';

const components = [StepperComponent, StepperSectionComponent, StepperHeaderComponent];

@NgModule({
  declarations: components,
  exports: components,
  imports: [CommonModule]
})
export class StepperModule {}
